const initialState = {
    loading: false,
    error: null,
    data: null,
  };

export const INOUTReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INOUT_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "INOUT_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload, // Success data
      };
    case "INOUT_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};